import type { ReactNode } from 'react';
import { flexRender, type Row, type RowData, type TableFeatures } from '@tanstack/react-table';
import { row_getVisibleCells } from '@tanstack/react-table/static-functions';
import { TableReward } from '../TableReward';
export interface TrBodyRowRewardProps<TFeatures extends TableFeatures, T extends RowData> {
  row?: Row<TFeatures, T>;
  skeletonRow?: ReactNode[];
}

/*
 * Table body row component
 *
 * @param row - row data
 * @param loading - loading state to show skeleton
 */
export function TrBodyRowReward<TFeatures extends TableFeatures, T extends RowData>({
  row,
  skeletonRow
}: TrBodyRowRewardProps<TFeatures, T>) {
  // 'use no memo': TanStack keeps this object's reference while table state (sorting, rows) changes.
  'use no memo';

  return <TableReward.Tr>
      {skeletonRow && skeletonRow.map((cell, index) => <TableReward.Td key={index}>{cell}</TableReward.Td>)}

      {row && row_getVisibleCells(row).map(cell_0 => <TableReward.Td key={cell_0.id}>
            <span className="text-xs">
              {flexRender(cell_0.column.columnDef.cell, cell_0.getContext())}
            </span>
          </TableReward.Td>)}
    </TableReward.Tr>;
}